import { ApiError } from '../../interop/problem-details';
import { globalState } from '../ui/global-state';

export const strInvalidBuildNumber = 'INVALID BUILD NUMBER';

// The last API error is held in shared globalState (globalThis-backed) rather than a
// module-local variable. This module is bundled SEPARATELY into each entry
// (app-index-v1.js, v6config-entrypoint.js, ...), so a module-local `let` gives every
// bundle its own copy: setLastApiError() in one bundle would never be visible to
// getLastApiError() in another (e.g. the api layer runs in app-index, the v6 editor
// reads it from v6config). Shared state bridges the bundles. It also stops rollup
// tree-shaking the assignment away as a dead store in bundles that only ever write the
// error (set) and never read it (get) — the globalState write is an observable side effect.
export function getLastApiError(): ApiError | null {
  return (globalState().lastApiError as ApiError | null) ?? null;
}
export function setLastApiError(error: ApiError | null) {
  globalState().lastApiError = error;
}
